export var appendChild = function (child, parent) {
    return parent.appendChild(child);
};
